class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();

    this.isHoveringMenu = false;
    this.isHoveringPanel = false;
    this.hideTimeout = null;

    this.mainDetailsToggle = this.querySelector("details");
    this.summary = this.querySelector("summary");
    this.content =
      this.mainDetailsToggle.querySelector("summary").nextElementSibling;
    this.mainDetailsToggle.addEventListener(
      "focusout",
      this.onFocusOut.bind(this)
    );
    this.mainDetailsToggle.addEventListener("toggle", this.onToggle.bind(this));
    this.summary.addEventListener("mouseenter", (event) => {
      this.isHoveringMenu = true;
      this.showPanel();
    });
    this.summary.addEventListener("mouseleave", (event) => {
      this.isHoveringMenu = false;
      this.hidePanel();
    });
    this.querySelector(".mega-menu__content").addEventListener(
      "mouseenter",
      (event) => {
        this.isHoveringPanel = true;
        this.showPanel();
      }
    );

    this.querySelector(".mega-menu__content").addEventListener(
      "mouseleave",
      () => {
        this.isHoveringPanel = false;
        this.hidePanel();
      }
    );
  }
  showPanel() {
    clearTimeout(this.hideTimeout);
    this.mainDetailsToggle.open = true;
  }

  hidePanel() {
    this.hideTimeout = setTimeout(() => {
      if (!this.isHoveringMenu && !this.isHoveringPanel) {
        this.mainDetailsToggle.open = false;
      }
    }, 100); // 小延迟避免“滑动间闪烁”
  }
  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute("open")) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute("open");
    this.mainDetailsToggle
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
  }
}

customElements.define("details-disclosure", DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.summary = this.mainDetailsToggle.querySelector("summary");
    this.header = document.querySelector(".header-wrapper");
    // this.summary.addEventListener("mouseenter", this.onToggle.bind(this));
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (
      document.documentElement.style.getPropertyValue(
        "--header-bottom-position-desktop"
      ) !== ""
    )
      return;
    document.documentElement.style.setProperty(
      "--header-bottom-position-desktop",
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define("header-menu", HeaderMenu);
